
import { Component, Prop, toNative, Vue, Watch } from 'vue-facing-decorator';
import loading from '@/components/Common/loading.vue';
import { MultimediaItem } from '@/entities/Program/MultimediaItem';
import ProgramMultimediaEditItemPane from '@/components/Program/ProgramDetail/Multimedia/ProgramMultimediaEditItemPane.vue';
import { FetchData, Root } from '@/main';
@Component({
  components: {
    ProgramMultimediaEditItemPane,
    loading,
  },
})
class ProgramMultimediaListAndEditItemView extends Vue {
  @Prop() private selectedEditMultimediaItem?: MultimediaItem;
  @Prop() private applicationborderColor?: string;
  private localMultimediaItem: MultimediaItem | null = null;
  private missingImage: string = require('@/assets/Images/ImageMissing.png');
  private manageIcon = require('@/assets/Images/three-dot-icon.svg');
  private showEditMultimedia?: boolean = false;
  private loaderBorderColor = '';
  private showLoading = false;
  private isMobileView = false;

  @Watch('selectedEditMultimediaItem')
  private onChangeMultimediaItem(val: MultimediaItem) {
    this.localMultimediaItem = val;
  }
  private mounted() {
    if (this.selectedEditMultimediaItem != null) {
      this.localMultimediaItem = this.selectedEditMultimediaItem;
    }
    if (this.applicationborderColor != null) {
      this.loaderBorderColor = this.applicationborderColor;
    }
    const self = this;
    Root.on(
      'program-multimedia-item-imageupdated-operation',
      (mi: any) => {
        if (mi != null) {
          if (mi.selectedMultimediaitem.Id === self.localMultimediaItem!.Id) {
            const selectedItem: MultimediaItem = mi.selectedMultimediaitem;
            self.selectItem(selectedItem, true);
          }
        }
      },
    );
    // check for ipad and mobile view
    if (window.innerWidth <= 768) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
    Root.on(
      'program-multimedia-close-others-operation',
      () => {
        this.showEditMultimedia = false;
      },
    );
  }
  private selectItem(image: MultimediaItem, scroll: boolean) {
    Root.emit('program-multimedia-close-others-operation');
    const selectedItem = image;
    this.localMultimediaItem = selectedItem;
    this.showEditMultimedia = true;
    this.$emit('program-multimedia-item-select-operation', selectedItem);
    if (scroll) {
      const el = document.querySelector('#dvMultimediaListing');
      if (el) {
        this.scrollToBottom(el);
      }
    }
  }
  private programMultimediaItemImageEditedOperation(
    multimedia: MultimediaItem,
  ) {
    this.selectItem(multimedia, false);
  }

  private programMultimediaItemCancelOperation(multimedia: MultimediaItem) {
    this.showEditMultimedia = false;
    this.localMultimediaItem = multimedia;
  }

  private programMultimediaItemEditedOperation(multimedia: MultimediaItem) {
    this.localMultimediaItem = multimedia;
    this.showEditMultimedia = false;
    this.$emit('program-multimedia-item-edit-operation', multimedia);
  }

  private programMultimediaItemImageUploadOperation(val: boolean) {
    this.$emit('program-multimedia-item-imageUpload-operation', val);
  }

  private DeleteSelectedMultimedia(multimedia: MultimediaItem) {
    this.Delete(multimedia);
  }
  private GetImageUrl(item: MultimediaItem) {
    if (item !== null) {
      return item.ThumbUrl;
    }
    return this.missingImage;
  }
  private Delete(multimedia: MultimediaItem) {
    if (!confirm('This will irrevobaly remove this multimedia\n\nContinue?')) {
      return;
    }
    FetchData('/Program/DeleteProgramMedia', JSON.stringify({
      id: multimedia.Id,
      programId: multimedia.ProgramId,
    }))
      .then((response) => {
        if (response.success === false) {
          // Server side validation failuere
          alert(this.$t('Message.UnableToDelete'));
        } else {
          // need information send to signalr
          const multimediaItemData = {
            id: multimedia.Id,
            programDetailType: 'Multimedia-Delete',
          };
          Root.emit('multimedia-update-signalr', multimediaItemData);
        }
      })
      .catch(() => {
        // Log error if required
      });
  }

  private scrollToBottom(el: Element) {
    setTimeout(() => {
      el.scrollTop = el.scrollHeight;
      el.scrollIntoView();
    }, 100);
  }
}
export default toNative(ProgramMultimediaListAndEditItemView);
